<template>
<div class="tp-root" :style="themePageStyle">
  <nav class="tp-topbar">
    <div class="container d-flex align-items-center py-2">
      <a href="javascript:void(0)" @click="$router.go(-1)" class="tp-back"><i class="mdi mdi-arrow-left"></i></a>
      <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" class="me-3" />
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">Terms &amp; Privacy</span>
      <span v-if="version" class="tp-version">v{{ version }}</span>
    </div>
  </nav>

  <div class="container tp-container">
    <!-- Acceptance banner — surfaces whether *you* have accepted the current
         version so a user coming back to /terms can confirm at a glance. -->
    <div v-if="accepted" class="tp-accept-banner tp-accept-yes">
      <i class="mdi mdi-check-circle" style="font-size:22px;"></i>
      <div>
        <div style="font-weight:700;">You accepted these terms</div>
        <div style="font-size:12px;opacity:.85;">
          Version {{ version }} · {{ formatAcceptedAt(acceptedAt) }}
        </div>
      </div>
    </div>
    <div v-else-if="userId" class="tp-accept-banner tp-accept-no">
      <i class="mdi mdi-alert-circle-outline" style="font-size:22px;"></i>
      <div>
        <div style="font-weight:700;">You haven't accepted the current terms yet</div>
        <div style="font-size:12px;opacity:.85;">
          Scroll to the end and tap Accept — required to keep listing / buying.
        </div>
      </div>
    </div>
    <div v-else class="tp-accept-banner tp-accept-anon">
      <i class="mdi mdi-information-outline" style="font-size:22px;"></i>
      <div style="font-size:13px;">
        <a href="javascript:void(0)" @click="$router.push('/login')" style="color:#BFA164;font-weight:600;text-decoration:none;">Sign in</a>
        to check whether you've accepted these terms.
      </div>
    </div>

    <div class="tp-card">
      <terms-content />
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import TermsContent from "@/components/flockr-legal/TermsContent.vue";
import { executeJson, flocker } from "@/api";
export default {
  name: "TermsPage",
  components: { TermsContent },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    version:'',
    accepted:false,
    acceptedAt:null,
    userId: sessionStorage.getItem('userId') || ''
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    var self=this;
    this.themeObserver=new MutationObserver(function(){self.darkMode=document.documentElement.getAttribute('data-theme')!=='light'});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.fetchVersion();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect()},
  methods:{
    async fetchVersion(){
      try{
        var r=await executeJson({function:'getTermsStatus',userId:sessionStorage.getItem('userId')||''},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.version    = r.data.data.currentVersion || '';
          this.accepted   = !!r.data.data.accepted;
          this.acceptedAt = r.data.data.acceptedAt || null;
        }
      }catch(e){}
    },
    formatAcceptedAt(ts){
      if (!ts) return '';
      try {
        var d = new Date(String(ts).replace(' ','T'));
        return d.toLocaleString('en-KE', { day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
      } catch(e) { return String(ts); }
    }
  }
};
</script>

<style scoped>
.tp-root{min-height:100vh}
.tp-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.tp-back{color:var(--fm-m,#A09888);font-size:22px;margin-right:12px;text-decoration:none}
.tp-version{margin-left:auto;color:var(--fm-s,#6B6356);font-size:12px}
.tp-container{padding-top:24px;padding-bottom:60px;max-width:920px}
.tp-accept-banner{display:flex;align-items:flex-start;gap:12px;border-radius:12px;padding:14px 18px;margin-bottom:16px;font-size:14px;line-height:1.4;border:1px solid transparent}
.tp-accept-yes{background:rgba(80,200,120,.10);border-color:rgba(80,200,120,.35);color:#50C878}
.tp-accept-no {background:rgba(255,171,0,.10);border-color:rgba(255,171,0,.35);color:#FFAB00}
.tp-accept-anon{background:rgba(191,161,100,.08);border-color:rgba(191,161,100,.3);color:var(--fm-h,#F5F0E8)}
html[data-theme="light"] .tp-accept-anon{color:#1A1A1A}
.tp-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:32px;color:var(--fm-h,#F5F0E8);line-height:1.7}
html[data-theme="light"] .tp-topbar{background:rgba(247,245,242,.96);border-bottom-color:#E8E2DA}
html[data-theme="light"] .tp-card{background:#FFFFFF;border-color:#E8E2DA;color:#1A1A1A}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .tp-container { padding-top: 16px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .tp-card { padding: 18px !important; border-radius: 10px !important; font-size: 14px; line-height: 1.6; }
  .tp-version { font-size: 10px; }
}
</style>
